import styled from 'styled-components';

import { Box } from '../../ui/Box';
import { theme } from '../../ui/theme';

const getBorderColor = (props: DropZoneProps) => {
    if (props.isDragReject) {
        return theme.colors.negative.emphasis;
    }

    if (props.isDragAccept || props.isDragActive) {
        return theme.colors.accent.emphasis;
    }

    return theme.colors.border.muted;
};

const getBackgroundColor = (props: DropZoneProps) => {
    if (props.isDragReject) {
        return theme.colors.negative.background;
    }

    if (props.isDragAccept || props.isDragActive) {
        return theme.colors.accent.background;
    }

    return theme.colors.background.default;
};

interface DropZoneProps {
    isDragAccept: boolean;
    isDragReject: boolean;
    isDragActive: boolean;
}

export const DropZone = styled(Box)<DropZoneProps>`
    display: flex;
    border-style: dashed;
    border-color: ${(props) => getBorderColor(props)};
    border-width: 1px;
    border-radius: ${theme.radii[4]};
    padding: ${theme.space[32]};
    background-color: ${(props) => getBackgroundColor(props)};
    flex-direction: column;
    align-items: stretch;
`;
